import { Box, Autocomplete, TextField, Chip } from "@mui/material";
import React from "react";
import ProfessionalAffiliation from "../../../../../types/ProfessionalAffiliation";
import Skill from "../../../../../types/Skill";

interface TechnologiesAutocompleteProps {
  index: number;
  affiliation: ProfessionalAffiliation;
  handleInput: (e: any, index: number, projectIndex?: number) => void;
  projectIndex: number;
  errors: Record<string, string>;
  removeErrorMessage: (field: string) => void;
  skills: Skill[];
}

export const TechnologiesAutocomplete: React.FC<
  TechnologiesAutocompleteProps
> = ({
  affiliation,
  handleInput,
  index,
  projectIndex,
  errors,
  removeErrorMessage,
  skills,
}) => {
  const skillsOptions = skills.map((skill) => skill.name);

  return (
    <Box>
      <Autocomplete
        sx={{ margin: "0 0 1rem 0" }}
        multiple
        options={skillsOptions}
        value={affiliation.projects[projectIndex].keyTechnologies || []}
        onChange={(event, newValue) => {
          handleInput(
            {
              target: {
                name: "keyTechnologies",
                value: newValue,
              },
            },
            index,
            projectIndex
          );
          removeErrorMessage(
            `affiliations[${index}].projects[${projectIndex}].keyTechnologies`
          );
        }}
        freeSolo
        renderInput={(params) => (
          <TextField
            variant="outlined"
            {...params}
            label="Technologies"
            error={
              !!errors[
                `affiliations[${index}].projects[${projectIndex}].keyTechnologies`
              ]
            }
            helperText={
              errors[
                `affiliations[${index}].projects[${projectIndex}].keyTechnologies`
              ]
            }
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, chipIndex) => (
            <Chip
              label={option}
              {...getTagProps({ index: chipIndex })}
              onDelete={() => {
                const newValue = value.filter((_, i) => i !== chipIndex);
                handleInput(
                  {
                    target: {
                      name: "keyTechnologies",
                      value: newValue,
                    },
                  },
                  index,
                  projectIndex
                );
                removeErrorMessage(
                  `affiliations[${index}].projects[${projectIndex}].keyTechnologies`
                );
              }}
            />
          ))
        }
      />
    </Box>
  );
};
